import React from 'react';

type PCComplianceProps = {
  id: number;
};

const PCCompliance: React.FC<PCComplianceProps> = ({ id }) => {
  return (
    <div id={`pc-compliance-${id}`} className="container my-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow rounded">
            <div className="card-header bg-primary text-white text-center">
              <h3 className="mb-3">
                Policy Compliance Module{' '}
                <span className="badge badge-light ml-2">Coming Soon</span>
              </h3>
            </div>
            <div className="card-body p-4">
              {/* Introductory highlight */}
              <p className="lead text-center">
                Streamline your audit preparation and maintain continuous
                compliance.
              </p>

              {/* Key benefits list */}
              <ul className="list-unstyled mb-4">
                <li>
                  <i
                    className="fa fa-check text-success mr-2"
                    aria-hidden="true"
                  ></i>
                  Align with <strong>SOC 2</strong>, <strong>ISO 27001</strong>,
                  and other standards
                </li>
                <li>
                  <i
                    className="fa fa-check text-success mr-2"
                    aria-hidden="true"
                  ></i>
                  Assess physical, virtual, cloud, and on-prem systems
                </li>
                <li>
                  <i
                    className="fa fa-check text-success mr-2"
                    aria-hidden="true"
                  ></i>
                  Immediate pass/fail results and compliance posture overview
                </li>
              </ul>

              {/* Call-to-action button */}
              <div className="text-center">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-lg"
                  disabled
                >
                  Notify Me
                </button>
              </div>
            </div>

            {/* Footer with feature ID */}
            <div className="card-footer text-muted text-center">
              CA ID: {id}
            </div>
          </div>

          {/* Placeholder notice for review with info style */}
          <div
            className="alert alert-light text-center mt-3"
            style={{ color: 'black' }}
            role="alert"
          >
            Note: This message is just a placeholder for review. and only
            visible to admin users.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PCCompliance;
